<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :value="alert" transition="scale-transition" >{{ alert_message }}</v-alert >
    </div>
    <!-- Title-->
    <header-component :headerTitle="headerText" />

    <!-- search-->

    <v-card-title style="padding: 28px 24px 4px 24px;">
      <!-- Search fields -->
      <v-row>
        <v-combobox v-model="selected_field" :items="field_items" item-title="key" item-value="key" label="Select Field" outlined style="max-width: 170px;" > </v-combobox>
        <v-text-field class="ml-2" prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" style="max-width: 180px;" outlined v-on:keyup.enter="loadData(active_tab)" ></v-text-field>
        <v-spacer></v-spacer>
      </v-row>
    </v-card-title>

    <!-- Data Table -->
    <v-layout column>
      <v-flex md6 style="overflow: auto">
        <v-data-table
          :dense="true"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :loading="loading"
          fixed-header
          height="100%"
          loading-text="Loading Data... Please wait"
          class="elevation-1"
        >
          <template #[`item.request_id`]="{ item }">
            <a @click="RequestDialog(item)" style="color: #1976d2;">
              <u> {{ item.request_id }}</u>
            </a>
          </template> 
        </v-data-table>
      </v-flex>
    </v-layout>

    <!-- pagination display -->
    <div>
      <v-row class="ml-2">
        <v-col cols="4" sm="1" class="PaddingItemPerPage">
          <v-select v-model="pageSize" :items="pageSizes" label="Items per page" @update:modelValue="handlePageSizeChange" ></v-select>
        </v-col>
        <span class="item-selected">
          <span v-if="selected.length == 1" >{{ selected.length }} Item Selected</span >
          <span v-if="selected.length > 1" >{{ selected.length }} Items Selected</span >
        </span>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="4" class="PaddingItemPerPage">
          <v-pagination v-model="page" :length="totalPages" total-visible="7" next-icon="mdi-menu-right" prev-icon="mdi-menu-left" @update:modelValue="handlePageChange" ></v-pagination>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
export default {
  components: {
    HeaderComponent
  },

  data() {
    return {
      headerText: "Pull Back Return Approval",
      alert_type: "success",
      alert: false,
      alert_message: "",
      loading: false,
      page: 1,
      totalPages: 1,
      selected: '',
      pageSize: 100,
      pageSizes: [100, 200, 500],
      search: "",
      search_tag: '',
      selected_field: "",
      active_tab: "",
      table_data: [
              { 'request_id' : "TG-34287"}
            ],
      headers: [],
    };
  },
  async created() {
    this.scrollToTop();
    this.loadData("Production Inventory");
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    showAlert(alert_type, alert_message) {
      this.scrollToTop();
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    loadData(tab, tab_action) {
      if (tab_action) {
        this.search_tag = "";
        this.selected_field = "";
      }
      this.page = 1;
      this.active_tab = tab;
      this.pageSize = 100;
      this.loading = false;
      this.selected = [];
      this.headers = [
          { text: "Request ID", align: "start", sortable: false, value: "request_id" },
          { text: "Pull Back Invite ID", value: "" },
          { text: "Customer/Entity", value: "" },
          { text: "Status", value: "" },
        ];
    },
    RequestDialog(item){
      const selected_id = this.selected.id
      this.$store.commit("setLotIds", {
          lotIds: selected_id,
          inventoryId: 'Pull Back Return Approval'
        });
      this.$router.push({ name: 'request_dialog' });
  },
  }
};
</script>

<style scoped>
.custom-control_outlined button {
  min-height: 56px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.42);
  border-style: solid;
}

.v-dialog__content:has(.filter-data) {
  justify-content: right;
  align-items: baseline;
  top: 13rem;
}

.item-selected {
  margin-top: 23px;
  position: absolute;
  left: 41%;
}

@media (max-height: 1104px) {
  .PaddingItemPerPage {
    padding: 8px !important;
  }
}

@media (min-height: 1126px) {
  .PaddingItemPerPage {
    padding: 24px !important;
  }
}
</style>
